import '../scss/search.scss';

window.addEventListener("DOMContentLoaded", function (event) {
	const resultsItems = document.querySelectorAll('[data-section]');
	const filters = document.querySelectorAll('[data-filter]');
	let activeFilters = [];
	if (resultsItems && filters) {
		filters.forEach(filter => {
			filter.addEventListener('click', function (e) {
				// e.preventDefault();
				const filterValue = this.dataset.filter;
				if (activeFilters.includes(filterValue)) {
					// remove filter value from the array
					activeFilters = activeFilters.filter(item => item !== filterValue);
					TrackEvent('off', filterValue)
				} else {
					activeFilters.push(filterValue);
					TrackEvent('on', filterValue)
				}
				// console.log(activeFilters, filterValue);
				if (activeFilters.length === 0) {
					resultsItems.forEach(item => {
						item.classList.remove('hidden');
					});
				} else {
					resultsItems.forEach(item => {
						if (activeFilters.includes(item.dataset.section)) {
							item.classList.remove('hidden');
						} else {
							item.classList.add('hidden');
						}
					});
				}
			});
		});
	}
	function TrackEvent(direction, filterName) {
		if (typeof dataLayer !== 'undefined') {
			dataLayer.push({
				'event': 'search-filter',
				'engagement_type': (direction === 'on' ? 'activate filter' : 'deactivate filter'),
				'engagement_target': filterName,
			});
		}
	}
});